import React, { useEffect, useState } from 'react';
import {
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  TextField,
} from '@material-ui/core';
import round from 'helpers/mathRound';


const QuoteItemSubscription = ({
  formik,
  index,
  item,
  selectedDataSource,
  product
}) => {
  const [loading, setLoading] = useState(false);

  const {
    touched,
    errors,
    handleChange,
    handleBlur,
    setFieldValue,
    setErrors,
    validateForm
  } = formik;

  const {
    sku,
    subscription_id,
    fixedPrice
  } = item;

  const {
    productAttributes,
    subscriptionOptions,
  } = selectedDataSource;

  const isSubscriptionActive = parseInt(productAttributes?.subscription_active, 10) === 1;
  const subscriptionLabel = isSubscriptionActive ? productAttributes?.subscription_label || 'Subscription Type' : 'Subscription Type';
  const subscriptionId = isSubscriptionActive ? subscription_id : '';

  const calculateAndUpdatePrice = (selectedOptionData) => {
    setLoading(true);

    const savings = +productAttributes?.savings || 0;
    const installmentPrice = selectedOptionData.installment_price || 0;
    const adjustmentPrice = selectedOptionData.adjustment_price || 0;
    const frequencyCount = selectedOptionData.frequency_count || 0;
    const savingsAmount = Number(savings) || 0;
    const productPrice = product?.price || 0;

    let newPrice;

    if (selectedOptionData?.id !== subscription_id) {
      newPrice = productPrice;
    } else if (fixedPrice !== productPrice) {
      newPrice = fixedPrice;
    } else if (isSubscriptionActive && (installmentPrice || adjustmentPrice)) {
      newPrice = round(installmentPrice + adjustmentPrice) + savingsAmount;
    } else {
      newPrice = productPrice + savingsAmount;
    }

    setFieldValue(`items[${index}].fixedPrice`, newPrice);
    setFieldValue(`items[${index}].subscriptionFrequency`, frequencyCount);

    setLoading(false);
  };

  useEffect(() => {
    if (!subscription_id && sku && subscriptionOptions.length && isSubscriptionActive) {
      const [selectedOptionData] = subscriptionOptions;

      if (selectedOptionData) {
        setFieldValue(`items[${index}].subscription_id`, selectedOptionData?.id);
        calculateAndUpdatePrice(selectedOptionData);
        validateForm().then(() => {
          setErrors({});
        });
      }
    }
  }, [sku]);

  useEffect(() => {
    if (subscription_id && sku) {
      const selectedOptionData = subscriptionOptions?.find((o) => o.id === Number(subscription_id));

      if (selectedOptionData) {
        calculateAndUpdatePrice(selectedOptionData);
      }
    }
  }, [sku, subscription_id]);

  const handleSubscriptionOptionChange = (event) => {
    handleChange(event);

    const selectedOptionData = subscriptionOptions.find((o) => o.id === event.target.value);

    if (selectedOptionData) {
      calculateAndUpdatePrice(selectedOptionData);
    }
  };

  const labelStyle: React.CSSProperties = {
    maxWidth: 'calc(100% - 24px)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  };

  return (
    <Grid item xs={12} lg>
      {loading ? (
        <Grid container direction="column" alignItems="center">
          <Grid item>
            <CircularProgress color="inherit" size={40} />
          </Grid>
        </Grid>
      ) : (
        <FormControl variant="outlined" fullWidth>
          <TextField
            fullWidth
            select
            label={subscriptionLabel}
            variant="outlined"
            name={`items[${index}].subscription_id`}
            value={subscriptionId}
            onChange={handleSubscriptionOptionChange}
            onBlur={handleBlur}
            disabled={!isSubscriptionActive || !subscriptionOptions?.length || !sku}
            InputLabelProps={{
              style: labelStyle
            }}
            error={touched.items?.[index]?.subscription_id && !!errors.items?.[index]?.subscription_id}
            helperText={touched.items?.[index]?.subscription_id && errors.items?.[index]?.subscription_id}
          >
            {subscriptionOptions?.length
              ? subscriptionOptions?.map((option) => (
                <MenuItem value={option.id} key={option.id}>
                  {option.frequency_count === 0 ? 'One Time' : option.sproduct_label}
                </MenuItem>
              ))
              : <MenuItem value="" >{'-'}</MenuItem>
            }
          </TextField>
        </FormControl>
      )}
    </Grid>
  );
};

export default QuoteItemSubscription;
